import instance from './instance';

export const fetchCalendarMeetings = ({ forceResync }) =>
  instance.get(`/calendar_meetings?force_resync=${forceResync}`);
